export const ICONS = {
  APPOINTMENT_COMPLETE: { name: 'check', classname: 'appointment-complete' },
  NO_SHOW_APPOINTMENT: {
    name: 'no_show_appointment',
    classname: 'no-show-appointment',
  },
  BILL_SENT: { name: 'money', classname: 'bill-sent' },
  INTERVENTION_CAR: { name: 'car', classname: 'intervention-type car' },
  INTERVENTION_CAR_ALERT: {
    name: 'car_alert',
    classname: 'intervention-type car_alert',
  },
  INTERVENTION_CONVEYING: {
    name: 'conveying',
    classname: 'intervention-type conveying',
  },
  INTERVENTION_HOME: { name: 'home', classname: 'intervention-type home' },
  ORIGIN_DEVICE: { name: 'device', classname: 'origin device' },
  ORIGIN_INSURER: { name: 'insurer', classname: 'origin insurer' },
  ORIGIN_PHONE_CALL: { name: 'phone_call', classname: 'origin phone_call' },
  ORIGIN_TROPHY: { name: 'trophy', classname: 'origin trophy' },
  ORIGIN_AICHAT: { name: 'aichat', classname: 'origin aichat' },
  REPLACEMENT_PART_UNAVAILABLE: {
    name: 'operation_vitre',
    classname: 'replacement-part unavailable',
  },
  REPLACEMENT_PART_ORDERED: {
    name: 'operation_vitre',
    classname: 'replacement-part ordered',
  },
  REPLACEMENT_PART_AVAILABLE: {
    name: 'operation_vitre',
    classname: 'replacement-part available',
  },
};
